import React from "react";
import { Tabs, TabsProps } from "antd";
import { MainBreadCrumbs } from "../Common/MainBreadCrumbs";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "../Context/ThemeContext";
import AddItems from "../Pages/Items/AddItems";
// import AddCategoryModel from "../Pages/Expenses&income/AddCategoryModel";
import { useClient } from "../Context/ClientContext";
import {
  findUserOnlyOnePremission,
  findUserPremission,
} from "../Pages/Users/Roles/UserSecurityFind";
import { useUser } from "../../Context/UserContext";
import { ISilderName } from "../Common/Routing/PageRoute";
import { SettingsSections } from "../Services/SettingService";
import { IPermissionActionType } from "../Pages/Users/Roles/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../Context/RoleContext";
import DisposedAssestNewModal from "../Pages/Assets/Dispose/DisposedAssestNewModal";
import AddAsset from "../Pages/Assets/AddAssetsVoucher/AddAsset";
// import DisposeAssetmodel from "../Pages/Assets/DisposeAssetmodel";

interface IProps {
  element: JSX.Element;
  silderName: ISilderName;
  breadcrumprops: {
    item?: string | null;
    path?: string;
  }[];
  menuprops: {
    showData: string;
    addButton?: string;
  }[];
}

const SalesInvoiceTemplate = (props: IProps) => {
  const navigate = useNavigate();
  const { accessSettings } = useUser();
  const themeData: any = useTheme();
  const location = useLocation();
  const [tabBreadCrumb, setTabBreadCrumb] = React.useState("");
  const [color, setColor] = React.useState(false);
  const changeColor = () => {
    if (window.scrollY >= 90) {
      setColor(true);
    } else {
      setColor(false);
    }
  };
  window.addEventListener("scroll", changeColor);
  const { companySettings, currentClient } = useClient();
  const { clientSpecificRole } = useUser();
  const [locationUrl, setLocationUrl] = React.useState<string>("");
  const [trigger, setTrigger] = React.useState<boolean>(false);
  const [width, setWidth] = React.useState<any>(window.innerWidth);
  const [itemTableTrigger, setItemTableTrigger] =
    React.useState<boolean>(false);
  const [open, setOpen] = React.useState(false);
  const [openItemModel, setOpenItemModel] = React.useState<any>({
    type: "",
    param: {},
  });
  React.useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  React.useEffect(() => {
    let splittedpath = location.pathname.split("/");
    let salesurl = splittedpath[splittedpath.length - 1];
    setLocationUrl(salesurl);
    let breadKey = salesurl.charAt(0).toUpperCase() + salesurl.slice(1);
    setTabBreadCrumb(breadKey);
  }, [location]);

  const onChange = (key: string) => {
    navigate(key);
  };

  const keyMap: { [key: string]: string } = {
    "Parties Group": "partiesGroup",

    "Item Group": "itemGroup",
    "Item Groups": "itemgroups",
    "Item Category": "itemCategory",
    "Item Locations": "itemlocations",

    "Proforma Invoices": "proformaInvoices",
    "Credit Notes": "creditNotes",
    "Sales Order": "order",

    "Purchase Bill": "purchaseBill",
    "Debit Note": "debitNote",
    "Purchase Out": "purchaseOut",
    "Purchase Order": "order",
    "Payment Out": "paymentOut",
    "Delivery Challan": "deliveryChallan",

    "Expenses Group": "expensesGroup",
    "Expenses Ledger": "expensesLedger",

    "Income Group": "incomeGroup",
    "Income Ledger": "incomeLedger",
    "Cost Centres": "costCentres",

    "Bank Accounts": "bankAccounts",
    "Cash In Hand": "cashInHand",
    "Loan Accounts": "loanAccounts",
    "Bank Reconciliation": "bankReconciliation",

    "Asset Purchase": "assetPurchase",
    "Assets Items": "assetsItems",
    "Share Capital": "sharecapital",

    "Aged Debtors": "debtors",
    "Aged Creditors": "creditors",

    "Company Info": "companyInfo",
    "Payment Term": "paymentTerm",
    "Opening Balance": "openingBalance",
    "Closing Entries": "closingEntries",
    "Default Ledger": "defaultLedger",
    "Terms And Conditions": "termsandConditions",
    "Lock Month": "lockmonth",

    "Sub Units": "subunits",
  };

  const keyconvertor = (item: string): string => {
    return keyMap[item] ?? item.trim().toLowerCase();
  };

  const createMenuItem = (
    item: { showData: string; addButton: string },
    onChange: (key: string) => void,
    isEnabled: boolean
  ) => {
    const key = keyconvertor(item?.showData);
    const label = (
      <div>
        {item?.showData && (
          <span style={{ padding: "0px 14px" }} onClick={() => onChange(key)}>
            <span>{item?.showData}</span>
          </span>
        )}
      </div>
    );
    return isEnabled ? { key, label } : false;
  };

  // Company setting
  const conditionHandlersCompanySetting: Record<
    string,
    (item: any) => boolean
  > = {
    // Setting tab
    "Company Info": () =>
      findUserPremission(
        [
          "Setting.Company.Info.View",
          "Setting.Company.Details.View",
          "Setting.Company.PaymentTerm.View",
          "Setting.Company.GST.View",
        ],
        clientSpecificRole(),
        currentClient?.id!
      ),
    Vouchers: () =>
      findUserPremission(
        [
          "Setting.Voucher.1.View",
          "Setting.Voucher.2.View",
          "Setting.Voucher.3.View",
          "Setting.Voucher.5.View",
          "Setting.Voucher.4.View",
          "Setting.Voucher.6.View",

          "Setting.Voucher.7.View",
          "Setting.Voucher.8.View",
          "Setting.Voucher.10.View",
          "Setting.Voucher.9.View",

          "Setting.Voucher.14.View",
          "Setting.Voucher.15.View",

          "Setting.Voucher.13.View",
          "Setting.Voucher.12.View",
          "Setting.Voucher.11.View",
        ],
        clientSpecificRole(),
        currentClient?.id!,
        [
          SettingsSections.Invoice,
          SettingsSections.PInvoice,
          SettingsSections.CrNote,
          SettingsSections.Receipt,
          SettingsSections.Quotation,
          SettingsSections.SOrder,

          // Purchase
          SettingsSections.PurInvoice,
          SettingsSections.DrNote,
          SettingsSections.Payment,
          SettingsSections.POrder,

          // expenses & income
          SettingsSections.Expenses,
          SettingsSections.Income,

          // Journal
          SettingsSections.Journal,
          // Contra
          SettingsSections.Contra,
          // Asset
          SettingsSections.Asset,
        ],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    Items: () =>
      findUserPremission(
        ["Setting.Item.View"],
        clientSpecificRole(),
        currentClient?.id!
      ),
    "Opening Balance": () =>
      findUserPremission(
        ["Setting.OpeningBalance.View"],
        clientSpecificRole(),
        currentClient?.id!
      ),
    Templates: () =>
      findUserPremission(
        ["Setting.Templates.View"],
        clientSpecificRole(),
        currentClient?.id!
      ),
    "Default Ledger": () =>
      findUserPremission(
        ["Setting.DefaultLedger.View"],
        clientSpecificRole(),
        currentClient?.id!
      ),
    "Terms And Conditions": () =>
      findUserPremission(
        [
          "Setting.TC.1.View",
          "Setting.TC.2.View",
          "Setting.TC.3.View",
          "Setting.TC.5.View",
          "Setting.TC.4.View",
          "Setting.TC.6.View",
          "Setting.TC.7.View",
          "Setting.TC.8.View",
          "Setting.TC.10.View",
          "Setting.TC.9.View",
          "Setting.TC.14.View",
          "Setting.TC.15.View",
          "Setting.TC.13.View",
          "Setting.TC.12.View",
          "Setting.TC.11.View",
        ],
        clientSpecificRole(),
        currentClient?.id!,
        [
          SettingsSections.Invoice,
          SettingsSections.PInvoice,
          SettingsSections.CrNote,
          SettingsSections.Receipt,
          SettingsSections.Quotation,
          SettingsSections.SOrder,

          // Purchase
          SettingsSections.PurInvoice,
          SettingsSections.DrNote,
          SettingsSections.Payment,
          SettingsSections.POrder,

          // expenses & income
          SettingsSections.Expenses,
          SettingsSections.Income,

          // Journal
          SettingsSections.Journal,
          // Contra
          SettingsSections.Contra,
          // Asset
          SettingsSections.Asset,
        ],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.TandC],
        }
      ),
    TDS: () =>
      currentClient?.tdsDeductible === true
        ? findUserPremission(
            ["Setting.TDS.View"],
            clientSpecificRole(),
            currentClient?.id!
          )
        : false,

    //   true &&
    // findUserSettingAccessSecurity(useAccessSettingsData, Setting_Type.TDS) === true

    TCS: () =>
      currentClient?.tcsApplicability === true
        ? findUserPremission(
            ["Setting.TCS.View"],
            clientSpecificRole(),
            currentClient?.id!
          )
        : false,
    // //   true &&
    // // findUserSettingAccessSecurity(useAccessSettingsData, Setting_Type.TDS) === true
    Email: () =>
      findUserPremission(
        ["Setting.Email.View"],
        clientSpecificRole(),
        currentClient?.id!
      ),
    Currencies: () =>
      findUserPremission(
        ["Setting.Currencies.View"],
        clientSpecificRole(),
        currentClient?.id!
      ),
    // Lock Month
    "Lock Month": () =>
      findUserPremission(
        ["Setting.LockMonth.View"],
        clientSpecificRole(),
        currentClient?.id!
      ),
  };

  // Party tab
  const conditionHandlersParty: Record<string, (item: any) => boolean> = {
    Parties: () =>
      findUserOnlyOnePremission(
        "Master.Ledger.Party.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
    "Parties Group": () =>
      findUserOnlyOnePremission(
        "Master.Group.Party.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
  };

  // Item tab
  const conditionHandlersItem: Record<string, (item: any) => boolean> = {
    Items: () =>
      findUserOnlyOnePremission(
        "Master.Item.View",
        clientSpecificRole(),
        currentClient?.id!
      ) === true,
    "Item Category": () =>
      companySettings?.setting?.item?.maintainCategory === true
        ? findUserOnlyOnePremission(
            "Master.Item.Category.View",
            clientSpecificRole(),
            currentClient?.id!
          )
        : false,
    Units: () =>
      findUserOnlyOnePremission(
        "Master.Item.Unit.View",
        clientSpecificRole(),
        currentClient?.id!
      ) === true,
    "Item Locations": () =>
      companySettings?.setting?.item?.maintainItemLocation
        ? findUserOnlyOnePremission(
            "Master.Item.Locations.View",
            clientSpecificRole(),
            currentClient?.id!
          )
        : false,
  };

  // Sales tab
  const conditionHandlersSales: Record<string, (item: any) => boolean> = {
    Invoices: () =>
      findUserPremission(
        ["Voucher.Sales.1.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.Invoice],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    "Proforma Invoices": () =>
      findUserPremission(
        ["Voucher.Sales.2.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.PInvoice],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    "Credit Notes": () =>
      findUserPremission(
        ["Voucher.Sales.3.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.CrNote],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    Receipts: () =>
      findUserPremission(
        ["Voucher.Sales.5.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.Receipt],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    Estimate: () =>
      findUserPremission(
        ["Voucher.Sales.4.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.Quotation],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    "Sales Order": () =>
      findUserPremission(
        ["Voucher.Sales.6.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.SOrder],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    Customer: () =>
      findUserPremission(
        ["Master.Ledger.Customer.View"],
        clientSpecificRole(),
        currentClient?.id!
      ),
  };

  // Purchase tab
  const conditionHandlersPurchase: Record<string, (item: any) => boolean> = {
    "Purchase Bill": () =>
      findUserPremission(
        ["Voucher.Purchase.7.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.PurInvoice],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    "Debit Note": () =>
      findUserPremission(
        ["Voucher.Purchase.8.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.DrNote],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    "Payment Out": () =>
      findUserPremission(
        ["Voucher.Purchase.10.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.Payment],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    "Purchase Order": () =>
      findUserPremission(
        ["Voucher.Purchase.9.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.POrder],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    Suppliers: () =>
      findUserOnlyOnePremission(
        "Master.Ledger.Suppliers.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
  };

  // Expenses & Income tab
  const conditionHandlersExpensesAndIncome: Record<
    string,
    (item: any) => boolean
  > = {
    Expenses: () =>
      findUserPremission(
        ["Voucher.Expenses.14.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.Expenses],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    "Expenses Ledger": () =>
      findUserOnlyOnePremission(
        "Master.Ledger.Expenses.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
    "Expenses Group": () =>
      findUserOnlyOnePremission(
        "Master.Group.Expenses.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
    Income: () =>
      findUserPremission(
        ["Voucher.Income.15.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.Income],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    "Income Ledger": () =>
      findUserOnlyOnePremission(
        "Master.Ledger.Income.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
    "Income Group": () =>
      findUserOnlyOnePremission(
        "Master.Group.Income.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
    "Cost Centres": () => true,
  };

  // Banking (Cash & Bank)
  const conditionHandlersBanking: Record<string, (item: any) => boolean> = {
    "Bank Accounts": () =>
      findUserPremission(
        ["Voucher.Contra.13.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.Contra],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    "Cash In Hand": () =>
      findUserPremission(
        ["Voucher.Contra.13.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.Contra],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    "Bank Reconciliation": () =>
      findUserOnlyOnePremission(
        "Master.BankReconciliation.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
    Cheque: () =>
      findUserOnlyOnePremission(
        "Master.Cheque.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
    "Loan Accounts": () =>
      findUserOnlyOnePremission(
        "Voucher.LoanAccount.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
  };

  // Fixed Asset Purchase tab
  const conditionHandlersFixedAssets: Record<string, (item: any) => boolean> = {
    "Asset Purchase": () =>
      findUserPremission(
        ["Voucher.Asset.11.View"],
        clientSpecificRole(),
        currentClient?.id!,
        [SettingsSections.Asset],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      ),
    "Assets Items": () => true,
    Disposed: () =>
      findUserOnlyOnePremission(
        "Voucher.Asset.DisposedAsset.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
    Location: () =>
      findUserOnlyOnePremission(
        "Master.AssestsLocation.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
  };

  // Master tab
  const conditionHandlersMaster: Record<string, (item: any) => boolean> = {
    Ledger: () =>
      findUserOnlyOnePremission(
        "Master.Ledger.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
    Group: () =>
      findUserOnlyOnePremission(
        "Master.Group.View",
        clientSpecificRole(),
        currentClient?.id!
      ),
    // findUserOnlyOnePremission(
    //   "Master.Group.View",
    //   clientSpecificRole(),
    //   currentClient?.id!
    // ),
  };

  // Items tab
  const items: TabsProps["items"] | any = props.menuprops?.map((item: any) => {
    let isConditionMet;
    console.log("data", item?.showData);
    switch (props?.silderName) {
      case ISilderName.Party:
        isConditionMet = conditionHandlersParty[item?.showData]?.(item);
        break;
      case ISilderName.Item:
        isConditionMet = conditionHandlersItem[item?.showData]?.(item);
        break;
      case ISilderName.Sales:
        isConditionMet = conditionHandlersSales[item?.showData]?.(item);
        break;
      case ISilderName.Purchase:
        isConditionMet = conditionHandlersPurchase[item?.showData]?.(item);
        break;
      case ISilderName.Expenses:
        isConditionMet =
          conditionHandlersExpensesAndIncome[item?.showData]?.(item);
        break;
      case ISilderName.Banking:
        isConditionMet = conditionHandlersBanking[item?.showData]?.(item);
        break;
      case ISilderName.FixedAsset:
        isConditionMet = conditionHandlersFixedAssets[item?.showData]?.(item);
        break;
      case ISilderName.Master:
        isConditionMet = conditionHandlersMaster[item?.showData]?.(item);
        break;
      case ISilderName.Settings:
        isConditionMet =
          conditionHandlersCompanySetting[item?.showData]?.(item);
        break;
      case ISilderName.Organisations:
        isConditionMet =
          conditionHandlersCompanySetting[item?.showData]?.(item);
        break;
    }

    // const isConditionMet = conditionHandlers[item?.showData]?.(item);
    console.log("isConditionMet", props.silderName, isConditionMet);

    if (isConditionMet !== undefined) {
      return createMenuItem(item, onChange, isConditionMet);
    }

    // Default case
    return {
      key: keyconvertor(item?.showData),
      label: (
        <div>
          {item?.showData && (
            <span
              style={{ padding: "0px 14px" }}
              onClick={() => onChange(keyconvertor(item.showData))}
            >
              <span>{item?.showData}</span>
            </span>
          )}
        </div>
      ),
      children: "",
    };
  });

  return (
    <>
      <MainBreadCrumbs
        breadCrumbItems={[...props.breadcrumprops, { item: tabBreadCrumb }]}
      />
      {width <= 768 ? (
        <Tabs
          size="small"
          className="Tabs-Responsive customTab"
          onChange={onChange}
          type="card"
          items={items}
        />
      ) : (
        locationUrl !== "" && (
          <Tabs
            activeKey={locationUrl}
            defaultActiveKey={locationUrl}
            items={items}
            className="ca-header-tab"
            tabBarGutter={11}
            tabBarStyle={{
              // backgroundColor: "#f5f8ff",
              // backgroundColor: "white",
              backgroundColor: "rgb(247, 248, 250)",
              position: "fixed",
              height: "32px",
              boxShadow: color ? "1px 2px 5px 4px red" : "",
              fontFamily: "'Open Sans','sans-serif'",
              fontWeight: 500,
              borderRadius: "6px",
              // marginLeft: "38px",
              // width:
              //   width <= 1024
              //     ? "91%"
              //     : themeData?.themeData?.silderSize
              //     ? "83%"
              //     : "calc(100vw - 100px)",
              width: "100%",
              // marginTop: "8px",
              // marginTop: "20px",
              zIndex: 5,
            }}
          />
        )
      )}
      <div>
        <div
          style={{
            // padding: "10px 20px 0px 20px",
            padding: "10px 15px 0px",
            // margin: width <= 768 ? "-20px 0px 0px 0px" : "40px 0px 0px 0px",
            margin: width <= 768 ? "-20px 0px 0px 0px" : "1px 0px 0px ",
            overflowY: "auto",
            // height: `calc(100vh - 112px)`,
            height: `calc(100vh - 74px)`,
            // backgroundColor: themeData?.themeData?.darkMode ? "" : "white",
            backgroundColor: themeData?.themeData?.darkMode ? "" : "#f7f8fa",
          }}
        >
          {props.element}
        </div>
      </div>
      {/*--------------- Add Items Props --------------- */}
      {openItemModel.type === "addItem" && (
        <AddItems
          open={openItemModel?.param.open}
          onCancel={() => setOpenItemModel({ type: "", param: {} })}
          setTrigger={setTrigger}
          itemPage={openItemModel?.param.itemType}
        />
      )}
      {/* {openItemModel.type === "addCategory" && (
        <AddCategoryModel
          isModalOpen={openItemModel?.param.open}
          setIsModalOpen={() => setOpenItemModel({ type: "", param: {} })}
          editCategory={{ id: null }}
        />
      )} */}
      {openItemModel.type === "addFixedAsset" && (
        <AddAsset
        // isModalOpen={openItemModel?.param.open}
        // setIsModalOpen={() => setOpenItemModel({ type: "", param: {} })}
        // editAsset={{ id: null }}
        // isConfirmation={false}
        // modelCancel={function (): void {
        //   throw new Error("Function not implemented.");
        // }}
        // setIsConfirmation={function (
        //   value: React.SetStateAction<boolean>
        // ): void {
        //   throw new Error("Function not implemented.");
        // }}
        // setTrigger={function (value: React.SetStateAction<boolean>): void {
        //   throw new Error("Function not implemented.");
        // }}
        />
      )}
      {openItemModel.type === "addDisposed" && (
        <DisposedAssestNewModal
          setReRender={setTrigger}
          reRender={trigger}
          isDisposeOpen={openItemModel?.param.open}
          setIsDisposeOpen={() => setOpenItemModel({ type: "", param: {} })}
        />
      )}
    </>
  );
};

export default SalesInvoiceTemplate;
